import { createSlice } from "@reduxjs/toolkit";
import toolbarConfiguration from "../components/Toolbar/toolbarConfig";

const {
  category,
  sku,
  DC,
  supplier,
  risk_type,
  tier2_suppliers,
  tier2_skus,
  supplier_org,
  assembly_item,
} = toolbarConfiguration.filterMap;

const mainSlice = createSlice({
  name: "main",
  initialState: {
    apiLoading: {
      header: false,
      date: false,
      supplier: false,
      product: false,
    },
    hdrData: "{}",
    prevHdrData: "{}",
    iconData: { bar_chart_data: [] },
    prevIconData: { bar_chart_data: [] },
    locationData: [],
    prevLocationData: [],
    productData: [],
    prevProductData: [],
    filters: {
      [category.filterId]: [],
      [sku.filterId]: [],
      [supplier.filterId]: [],
      [DC.filterId]: [],
      [tier2_suppliers.filterId]: [],
      [tier2_skus.filterId]: [],
      [risk_type.filterId]: [],
      [supplier_org.filterId]: [],
      [assembly_item.filterId]: [],
      country: [],
    },
    resetTriggered: false,
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setHdrData(state, action) {
      state.hdrData = action.payload;
    },
    setFilters(state, action) {
      const { filters, filterId } = action.payload;
      const currentFilters = state.filters;

      if (filterId && filterId !== "status") {
        delete filters[filterId];
      }

      state.filters = {
        ...currentFilters,
        ...filters,
      };
    },
    setPrevHdrData(state, action) {
      state.prevHdrData = action.payload;
    },
    setIconData(state, action) {
      state.iconData = action.payload;
    },
    setPrevIconData(state, action) {
      state.prevIconData = action.payload;
    },
    setResetTriggered(state, action) {
      state.resetTriggered = action.payload;
    },
  },
});

export const {
  setLoader,
  setHdrData,
  setPrevHdrData,
  setIconData,
  setPrevIconData,
  setFilters,
  setResetTriggered,
} = mainSlice.actions;

export default mainSlice.reducer;
